import { render, staticRenderFns } from "./StationInfo.vue?vue&type=template&id=71279562&scoped=true"
import script from "./StationInfo.vue?vue&type=script&lang=js"
export * from "./StationInfo.vue?vue&type=script&lang=js"
import style0 from "./StationInfo.vue?vue&type=style&index=0&id=71279562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71279562",
  null
  
)

export default component.exports